import useDashboardStore from "store/project/data/useDashboardStore";
import useProjectDataStore from "store/useProjectDataStore";
import { StyledTitleBar } from "./style";

export const TitleBar = () => {
  const { connectDatasetMode, projectData, isProjectInfoDashboard } =
    useProjectDataStore();
  const { gridSizeData } = useDashboardStore();

  return (
    <StyledTitleBar>
      {isProjectInfoDashboard && (
        <div className="info-wrap">
          {projectData.projectName && (
            <p className="title">{projectData.projectName}</p>
          )}
          {!connectDatasetMode && (
            <div className="info">
              <div className="columns">
                <p>
                  Columns <span>{gridSizeData.columns.toLocaleString()}</span>
                </p>
              </div>
              <div className="rows">
                <p>
                  Rows <span>{gridSizeData.rows.toLocaleString()}</span>
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </StyledTitleBar>
  );
};
